import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconDiscordBranded$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconDiscordBranded extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'c0dc8db0923aca454131d46cf493a92283f1fea9', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '13c391de3853472d6231d9df91b2279ad2587ca2', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'ab935bb6a0b28745f18c05d27493cad92817e493', d: "M17.248 5.143A15 15 0 0 0 13.534 4q-.263.47-.476.967a13.8 13.8 0 0 0-4.12 0Q8.724 4.472 8.461 4a15 15 0 0 0-3.717 1.145c-2.35 3.477-2.987 6.868-2.669 10.21a15 15 0 0 0 4.555 2.287q.554-.745.975-1.573a9.7 9.7 0 0 1-1.536-.733q.195-.142.377-.283a10.7 10.7 0 0 0 9.106 0q.185.152.377.283-.737.435-1.54.735.421.827.976 1.571a14.9 14.9 0 0 0 4.558-2.285c.373-3.876-.639-7.236-2.676-10.214M8.01 13.3c-.888 0-1.621-.805-1.621-1.796 0-.992.708-1.804 1.618-1.804s1.638.813 1.623 1.804c-.016.99-.715 1.796-1.62 1.796m5.98 0c-.889 0-1.62-.805-1.62-1.796 0-.992.708-1.804 1.62-1.804s1.634.813 1.618 1.804c-.015.99-.713 1.796-1.618 1.796", fill: "#5865F2" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-discord-branded", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-discord-branded"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-discord-branded":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconDiscordBranded$1);
            }
            break;
    } });
}

const CosmosIconDiscordBranded = CosmosIconDiscordBranded$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconDiscordBranded, defineCustomElement };
